import { Component, OnInit } from '@angular/core';
import {TooltipBaseComponent} from '../tooltip-base/tooltip-base.component';

@Component({
  selector: 'app-tooltip-conversion-metric',
  templateUrl: './tooltip-conversion-metric.component.html',
  styleUrls: ['./tooltip-conversion-metric.component.scss']
})
export class TooltipConversionMetricComponent extends TooltipBaseComponent implements OnInit {

  ngOnInit(): void {
  }

}
